/**
 * API Service for Production Module
 * Uses the same authentication as the main app
 */
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// Create axios instance for production module
const prodApi = axios.create({
  baseURL: `${API_BASE}/api/prod`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add interceptor to include auth token from localStorage
prodApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for auth errors
prodApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default prodApi;

// Helper exports for common operations
export const getProdStats = () => prodApi.get('/stats');
export const getMarcas = () => prodApi.get('/marcas');
export const getTipos = () => prodApi.get('/tipos');
export const getEntalles = () => prodApi.get('/entalles');
export const getTelas = () => prodApi.get('/telas');
export const getHilos = () => prodApi.get('/hilos');
export const getModelos = () => prodApi.get('/modelos');
export const getRegistros = () => prodApi.get('/registros');
export const getTallasCatalogo = () => prodApi.get('/tallas-catalogo');
export const getColoresCatalogo = () => prodApi.get('/colores-catalogo');
export const getHilosEspecificos = () => prodApi.get('/hilos-especificos');
